// Action Types
export const SUBMIT_COMPETITOR_PROFILE_V3_REQUEST =
  "SUBMIT_COMPETITOR_PROFILE_V3_REQUEST";
export const SUBMIT_COMPETITOR_PROFILE_V3_SUCCESS =
  "SUBMIT_COMPETITOR_PROFILE_V3_SUCCESS";
export const SUBMIT_COMPETITOR_PROFILE_V3_FAILURE =
  "SUBMIT_COMPETITOR_PROFILE_V3_FAILURE";

// Action Creators
export const submitCompetitorProfileV3Request = (formData) => ({
  type: SUBMIT_COMPETITOR_PROFILE_V3_REQUEST,
  payload: formData,
});

export const submitCompetitorProfileV3Success = (message) => ({
  type: SUBMIT_COMPETITOR_PROFILE_V3_SUCCESS,
  payload: message,
});

export const submitCompetitorProfileV3Failure = (error) => ({
  type: SUBMIT_COMPETITOR_PROFILE_V3_FAILURE,
  payload: error,
});
